import * as React from 'react';
import {Platform, useWindowDimensions, View} from 'react-native';
import Svg, {Polygon} from 'react-native-svg';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import testProperties from '/util/testing/testProperties';

import {styles} from './Delta.style';

interface DeltaProps {
  style: {
    base: {};
    icon: {};
    text: {};
  };
  value: number;
  testID: string | null;
}

export const Delta: React.FC<DeltaProps> = ({
  style: styleProp = {},
  value = 0,
  testID = null,
}) => {
  const {fontScale} = useWindowDimensions();
  const scaledIconSize = Math.max(10, Math.min(16 * fontScale, 32));

  const style = [styles.base];
  style.push(styleProp.base);
  const renderedValue = isFinite(value) ? Math.abs(value).toFixed(1) : 'N/A';
  let iconValueStyle = styles.iconZero;
  let iconName = 'triangle';
  let accessibilityIconLabel = '';

  if (value > 0) {
    // @ts-expect-error TS(2741): Property 'display' is missing in type '{ color: st... Remove this comment to see the full error message
    iconValueStyle = styles.iconPositive;
    iconName = 'trendUp';
    accessibilityIconLabel = `Up by ${renderedValue}%`;
  } else if (value < 0) {
    // @ts-expect-error TS(2741): Property 'display' is missing in type '{ color: st... Remove this comment to see the full error message
    iconValueStyle = styles.iconNegative;
    iconName = 'trendDown';
    accessibilityIconLabel = `Down by ${renderedValue}%`;
  }

  const iconStyle = {
    ...styles.icon,
    ...iconValueStyle,
    ...(styleProp.icon || {}),
  };

  const textStyle = {
    ...styles.text,
    ...(styleProp.text || {}),
  };

  return (
    <View
      {...testProperties('delta-view')}
      style={style}
      accessibilityLabel={accessibilityIconLabel}
      accessible={true}>
      {isFinite(value) && (
        <>
          {Platform.OS === 'android' ? (
            <View style={{...iconStyle}}>
              {value > 0 ? (
                <Svg
                  width={scaledIconSize}
                  height={scaledIconSize}
                  viewBox="0 0 16 16">
                  <Polygon
                    points="8,4 14,14 2,14"
                    fill={iconStyle.color || '#00C851'}
                  />
                </Svg>
              ) : (
                <Svg
                  width={scaledIconSize}
                  height={scaledIconSize}
                  viewBox="0 0 16 16">
                  <Polygon
                    points="8,12 14,2 2,2"
                    fill={iconStyle.color || '#FF4444'}
                  />
                </Svg>
              )}
            </View>
          ) : (
            <Icon
              name={iconName}
              style={{
                ...iconStyle,
                fontSize: scaledIconSize,
              }}
              accessibilityLabel={accessibilityIconLabel}
            />
          )}
        </>
      )}

      <Text
        allowFontScaling
        maxFontSizeMultiplier={2}
        accessible={false}
        testID={testID}
        variant="subheading"
        emphasis="low"
        style={textStyle}>
        {renderedValue}%
      </Text>
    </View>
  );
};

export default Delta;
